import { AlertTriangle, XCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { BudgetAlert } from '@/hooks/useBudgetAlerts';
import { formatCurrency } from '@/lib/foco-calculations';

interface BudgetAlertBannerProps {
  warningAlerts: BudgetAlert[];
  exceededAlerts: BudgetAlert[];
  currency?: string;
}

export function BudgetAlertBanner({ warningAlerts, exceededAlerts, currency = 'CRC' }: BudgetAlertBannerProps) {
  if (warningAlerts.length === 0 && exceededAlerts.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      {exceededAlerts.length > 0 && (
        <Alert variant="destructive">
          <XCircle className="h-4 w-4" />
          <AlertTitle>¡Presupuesto excedido!</AlertTitle>
          <AlertDescription>
            {exceededAlerts.map((a, i) => (
              <span key={a.category}>
                {a.categoryLabel} ({formatCurrency(Math.abs(a.remaining), currency)} extra)
                {i < exceededAlerts.length - 1 ? ', ' : ''}
              </span>
            ))}
          </AlertDescription>
        </Alert>
      )}
      
      {warningAlerts.length > 0 && (
        <Alert className="border-warning bg-warning/10">
          <AlertTriangle className="h-4 w-4 text-warning" />
          <AlertTitle className="text-foreground">Cerca del límite</AlertTitle>
          <AlertDescription className="text-muted-foreground">
            {warningAlerts.map((a, i) => (
              <span key={a.category}>
                {a.categoryLabel} ({Math.round(a.percentage)}% usado)
                {i < warningAlerts.length - 1 ? ', ' : ''}
              </span>
            ))}
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
